"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndeterminateIcon = void 0;
var react_1 = __importDefault(require("react"));
var build_svg_icon_1 = require("./build-svg-icon");
exports.IndeterminateIcon = (0, build_svg_icon_1.buildSvgIcon)(react_1.default.createElement("rect", { x: "6", y: "11", width: "12", height: "2", rx: "1" }), 'IndeterminateIcon');
exports.default = exports.IndeterminateIcon;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5kZXRlcm1pbmF0ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL2ljb25zL0luZGV0ZXJtaW5hdGUudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLGdEQUEwQjtBQUMxQixtREFBZ0Q7QUFFbkMsUUFBQSxpQkFBaUIsR0FBRyxJQUFBLDZCQUFZLEVBQzNDLHdDQUFNLENBQUMsRUFBQyxHQUFHLEVBQUMsQ0FBQyxFQUFDLElBQUksRUFBQyxLQUFLLEVBQUMsSUFBSSxFQUFDLE1BQU0sRUFBQyxHQUFHLEVBQUMsRUFBRSxFQUFDLEdBQUcsR0FBRyxFQUNsRCxtQkFBbUIsQ0FDcEIsQ0FBQztBQUVGLGtCQUFlLHlCQUFpQixDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./node_modules/@angi/icons/icons/Indeterminate.js
// module id = 3422
// module chunks = 25